import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const EASE = [0.16, 1, 0.3, 1];

export default function Blog() {
  const { t } = useTranslation();
  const articles = t("blog.articles", { returnObjects: true });

  return (
    <main data-testid="blog-page">
      <Header />
      <div className="pt-36 pb-24 max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: EASE }}>
          <p className="text-xs font-medium uppercase tracking-[0.25em] text-mint mb-4">{t("blog.kicker")}</p>
          <h1 className="font-display font-semibold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl text-balance">
            {t("blog.title")}
          </h1>
          <p className="mt-4 text-base md:text-lg text-white/55 max-w-xl">{t("blog.sub")}</p>
        </motion.div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <motion.div
              key={a.slug}
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.15 + i * 0.12, ease: EASE }}
            >
              <Link
                to={`/blog/${a.slug}`}
                data-testid={`blog-page-card-${a.slug}`}
                className="group flex flex-col h-full rounded-2xl border border-white/8 bg-card p-8 transition-colors duration-300 hover:border-mint/30"
              >
                <div className="flex items-center justify-between">
                  <span className="rounded-full bg-mint/10 border border-mint/20 px-3 py-1 text-[11px] font-medium text-mint">{a.tag}</span>
                  <ArrowUpRight className="w-4 h-4 text-white/30 transition-all duration-200 group-hover:text-mint" strokeWidth={1.5} />
                </div>
                <h2 className="mt-6 font-display font-semibold text-white text-xl tracking-tight leading-snug">{a.title}</h2>
                <p className="mt-3 text-sm text-white/50 leading-relaxed flex-1">{a.excerpt}</p>
                <p className="mt-6 text-xs text-white/35">{a.date} · {a.readTime}</p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
}
